export default __webpack_public_path__ + "static/media/q.b0de25de.svg";